import { render, staticRenderFns } from "./HostsSection.vue?vue&type=template&id=7f5e71ba&scoped=true"
import script from "./HostsSection.vue?vue&type=script&lang=js"
export * from "./HostsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5e71ba",
  null
  
)

export default component.exports